var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    fill: "white",
    stroke: "#336AB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7841 10.5728C17.3239 10.5728 16.9523 10.9445 16.9523 11.4046L16.9464 17.1682L11.1769 17.1682C10.7168 17.1682 10.3451 17.5399 10.3451 18C10.3451 18.4601 10.7168 18.8318 11.1769 18.8318L16.9464 18.8318L16.9464 24.6013C16.9464 25.0614 17.318 25.4331 17.7782 25.4331C18.2383 25.4331 18.61 25.0614 18.61 24.6013V18.8318H24.3794C24.8396 18.8318 25.2112 18.4601 25.2112 18C25.2112 17.5399 24.8396 17.1682 24.3794 17.1682H18.61V11.3987C18.61 10.9504 18.2324 10.5728 17.7841 10.5728Z",
    fill: "#336AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleIcon);
export default __webpack_public_path__ + "static/media/AddCircleIcon.b59e33c946d89308123847bf4f8f93e8.svg";
export { ForwardRef as ReactComponent };